import { ResolutionResponseItem } from "../../../common/api/orders-api/resolution/responses/ResolutionResponseItem";

export interface ResolutionListingItem {
    id: string;
    name: string;
    width: number;
    height: number;
    isModified?: boolean;
}

export const mapToResolutionListingItem = (item: ResolutionResponseItem): ResolutionListingItem => {
    return {
        id: item.id,
        name: item.name,
        height: item.height,
        width: item.width
    };
};
